import { createElement, useState } from 'react'
import { Body, Box, Icon, H4 } from '../widgets'
import { useBackground, useShell } from '../layout'

export const Dashboard = ({ title = 'Super User', goBack, options }) => {
  const [optionsIndex, setOptionsIndex] = useState(0)

  useBackground().set({ active: true, background: null })
  useShell({ active: true, mode: 'authenticated hide-mobile-header', headerBackground: 'black' })

  const { component, props } = options[optionsIndex]

  return (
    <Box fullWidth column>
      <Box className="settings-screen" fullWidth height="100%">
        <Box
          className="settings-options"
          column
          container
        >
          <Box column gap={16}>
            <H4 color="black">{title}</H4>
            <Box height={1} background="black" fullWidth />
          </Box>
          <Box className="settings-nav-options black-scroller" column overflowY="auto">
            {goBack && (
              <Box onClick={goBack} cursor="pointer" justifyContent="left" gap={8} py={12}>
                <Icon icon="LeftArrow" fill="black"/>
                <Body bold alt>Super User Controls</Body>
              </Box>
            )}
            {options.map(({ title, icon }, index) => (
              <Box
                fullWidth
                gap={8}
                cursor="pointer"
                key={index}
                alignItems="center"
                onClick={() => setOptionsIndex(index)}
                className={`option ${optionsIndex === index ? 'selected-option' : ''}`}
              >
                <Icon size={24} fill={optionsIndex === index ? 'white' : 'black'} icon={icon}/>
                <Body bold={optionsIndex === index}>{title}</Body>
              </Box>
            ))}
          </Box>
        </Box>
        <Box fullWidth className="settings-section">
          {createElement(component, { superUserMode: true, ...props })}
        </Box>
      </Box>
    </Box>
  )
}